import { render, staticRenderFns } from "./LandingMsg.vue?vue&type=template&id=6621965f&scoped=true&"
import script from "./LandingMsg.vue?vue&type=script&lang=js&"
export * from "./LandingMsg.vue?vue&type=script&lang=js&"
import style0 from "./LandingMsg.vue?vue&type=style&index=0&id=6621965f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621965f",
  null
  
)

export default component.exports